const Construccion = () => {
  return (
    <>
      <div>
        <p className="p-0 m-0 h4 text-center text-sm-left font-weight-bold">
          EN CONSTRUCCIÓN
        </p>
        <hr></hr>
        <div className="pl-5 pt-3 pr-5">
          <p className="p-0 m-0 h6 font-weight-bold">PROMOCIONES EN CURSO</p>
          <hr></hr>

          <p>
            Actualmente no tenemos ninguna obra en marcha ni instalaciones
            disponibles. <br></br>Si lo desea puede ponerse en contacto con
            nosotros y dejarnos sus datos, de esta forma le avisaremos cuando se
            inice un nuevo proyecto que pueda ser de su interés.
          </p>
        </div>
      </div>
    </>
  );
};

export default Construccion;
